var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tr',_vm._l((_vm.columns),function(column,index){return _c('b-th',{key:index,staticClass:"text-center text-nowrap"},[_vm._v(_vm._s(column.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }